import React from "react";
import { connect } from "react-redux";
import { putClientUserDetails, getClientManagementList, getClientUserList } from "../Actions/ClientManagementAPI";
import { confirmAlert } from 'react-confirm-alert';
import "react-datepicker/dist/react-datepicker.css";
import AddIcon from "../UIComponents/AddIcon";
import { toast } from "react-toastify";
import axios from "axios";
import API from "../helpers/api";
import swal from "sweetalert";

let user = JSON.parse(localStorage.getItem("currentUser"));
const Clientlist = {
  companyName: "",
  email: "",
  phone1: "",
  phone2: "",
  address: "",
  createdBy: "",
}
let searchData = {
  Name: '',
  PageNumber: 1,
  PageSize: 25
};

class ClientManagementEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ClientInfo: {
        clientId: 0,
        companyName: "",
        email: "",
        phone: "",
        address: "",
        isDeleted: false,
        modifiedBy: "",
        isTeFromApplicable: false
      },
      owner: false,
      management: false,
      FleetManager: [],
      TechSuperintendent: [],
      TechExecutive: []
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.UpdateData = this.UpdateData.bind(this);
  }

  componentDidMount() {
    const{dispatch}=this.props;
    this.props.dispatch({ type: 'SubBannerTitle', data: "Client Management" });
    let url = `${API.GetClientUserArray}`;
    axios.get(url)
        .then((response) => {
            if(response.status===200){
                dispatch({
                    type: "getFleetManagerArrayListSuccess",
                    data: response.data,

                })
            }
             })
        .catch((error) => {
            dispatch({
                type: "getFleetManagerArrayListFailure",
                error: "ERROR"
            })
        })
  }
  

  static getDerivedStateFromProps(nextProps, prevState) {
    const { ClientDetails, dispatch, fleetManagerlist, TechExecutivelist, TechSuperintendentlist, ClientUserDetails } = nextProps;
    if (ClientDetails && ClientDetails !== "") {
      prevState.ClientInfo.clientId = ClientDetails.clientId;
      prevState.ClientInfo.companyName = ClientDetails.companyName;
      prevState.ClientInfo.email = ClientDetails.email;
      prevState.ClientInfo.phone = ClientDetails.phone;
      prevState.ClientInfo.address = ClientDetails.address;
      prevState.ClientInfo.isTeFromApplicable = ClientDetails.isTeFromApplicable;
      dispatch({ type: "ClientDetails", data: "" });
    }
    if (fleetManagerlist) {
      prevState.FleetManager = fleetManagerlist;
    }
    if (TechSuperintendentlist) {
      prevState.TechSuperintendent = TechSuperintendentlist;
    }
    if (TechExecutivelist) {
      prevState.TechExecutive = TechExecutivelist;
    }
  }

  UpdateData() {
    const { dispatch } = this.props;
     if (this.state.ClientInfo.email !== "" && this.state.ClientInfo.companyName !== "") {
      let url2 = `${API.userExist}?Mail=${this.state.ClientInfo.email}&Id=${this.state.ClientInfo.clientId}`
      axios.get(url2, {
        headers: {
          key: user.accessToken
        }
      })
        .then((response) => {
          if (response.data === true) {
    let url = `${API.Clientlist}`;
    axios.put(url, this.state.ClientInfo, {
      headers: {
        key: user.accessToken,
      }
    })
      .then((response) => {
        toast.success("Updated Successfully", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        dispatch(getClientManagementList(searchData));
        dispatch({ type: "GetTechExecutivelist", data: null });
        dispatch({ type: "GetTechSuperintendentlist", data: null });
        dispatch({ type: "GetFleetManagerlist", data: null });
        this.props.history.push("/Home/Management/Client");
        dispatch({
          type: "putClientDetailsSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "putClientDetailsFailure",
          error: "ERROR"
        })
      })
    } else if (response.data === false) {
            swal('Error!', 'User already exist. Please change the email', 'warning');
            this.state.ClientInfo.email = "";
            this.setState({});
          }
          dispatch({
            type: 'getUserExistListSuccess',
            data: response.data
          })
        })
        .catch((error) => {
          dispatch({
            type: 'getUserExistListFailure',
            data: "error"
          })
        })
      }else if (this.state.ClientInfo.companyName == "" && this.state.ClientInfo.email == "") {
      swal('Error!', 'Name and Email is mandatory', 'warning');
    } else if (this.state.ClientInfo.companyName == "") {
      swal('Error!', 'Name is mandatory', 'warning');
    } else {
      swal('Error!', 'Email is mandatory', 'warning');
    }
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    if (nodeName === "owner") {
      this.state.ClientInfo.clientType = "Owner";
      this.setState({
        owner: true,
        management: false
      });
    } else if (nodeName === "management") {
      this.state.ClientInfo.clientType = "Management Company";
      this.setState({
        owner: true,
        management: false
      });
    } else {
      this.state.ClientInfo[nodeName] = e.target.value;
      this.setState({});
    }
  }

  handleCheckBoxChange(e) {
    if (e.target.checked) {
      this.state.ClientInfo.isTeFromApplicable = true
      this.setState({});
    } else {
      this.state.ClientInfo.isTeFromApplicable = false
      this.setState({});
    }
  }

  render() {
    const { showSidePane, ClientUserDetails } = this.props;
    return (
      <div className="full-height">
        <div className="row pt-3">
          <div className="col-lg-12">
            <div className="panel-box">
              <div className="row search-filter-box">
                <div className="col-lg-12">
                  <div className="card mt-2 MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                    <div className="card-body" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}>
                      <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>Basic Information</h5>
                    </div>
                  </div>
                  <div className="row search-filter-box pb-4">
                    <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                      <label className="form-label">Name</label>
                      <input
                        className="form-control"
                        type="text"
                        name="companyName"
                        placeholder="Name"
                        onChange={e => this.handleInputChange(e)}
                        value={this.state.ClientInfo.companyName}
                      ></input>
                    </div>
                    <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                      <label className="form-label">Email</label>
                      <input
                        className="form-control"
                        type="email"
                        name="email"
                        placeholder="Email"
                        onChange={e => this.handleInputChange(e)}
                        value={this.state.ClientInfo.email}
                        // readOnly
                      ></input>
                    </div>
                    <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                      <label className="form-label">Phone</label>
                      <input
                        className="form-control"
                        type="text"
                        name="phone"
                        placeholder="Phone"
                        onChange={e => this.handleInputChange(e)}
                        value={this.state.ClientInfo.phone}
                      ></input>
                    </div>
                    <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                      <label className="form-label">Address</label>
                      <input
                        className="form-control"
                        type="textarea"
                        name="address"
                        placeholder="Address"
                        onChange={e => this.handleInputChange(e)}
                        value={this.state.ClientInfo.address}
                      ></input>
                    </div>
                    <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                      <label className="form-label" >TE Forms Applicable</label><br></br>
                      <input type="checkbox" name="isTeFromApplicable" checked={this.state.ClientInfo.isTeFromApplicable} onChange={(e) => this.handleCheckBoxChange(e)}></input>
                    </div>
                  </div>
                  <div className="row ">
                    <div className="col-lg-12">
                      <div className=" card MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                        <div className="card-body flex" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}>
                          <h5 className="card-title m-2" style={{ color: "092a51" }}>Fleet Managers</h5>
                          <div className="m-1 flex" onClick={() => this.showFleetManagersSidePane()}>
                            <AddIcon />
                          </div>
                        </div>
                      </div>
                      <div className="search-filter-box pt-4">
                        {ClientUserDetails ? this.renderFleetManagerCard() : null}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className=" card MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                        <div className="card-body flex" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}>
                          <h5 className="card-title m-2" style={{ color: "092a51" }}>Technical Superintendents </h5>
                          <div className="m-1 flex" onClick={() => this.showTechSuperintendentsSidePane()}>
                            <AddIcon />
                          </div>
                        </div>
                      </div>
                      <div className="search-filter-box pt-4">
                        {ClientUserDetails ? this.renderTechSuperintendentCard() : null}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className=" card MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                        <div className="flex card-body" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}>
                          <h5 className="card-title m-2" style={{ color: "092a51" }}>Technical Executive  </h5>
                          <div className="m-1 flex" onClick={() => this.showTechExecutiveSidePane()}>
                            <AddIcon />
                          </div>
                        </div>
                      </div>
                      <div className="search-filter-box pt-4">
                        {ClientUserDetails ? this.renderTechExecutiveCard() : null}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 py-2">
                      <div className="mb-1 search-btn-col" style={{ textAlign: "end" }}>
                        <button
                          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                          type="submit" onClick={() => this.UpdateData()}>Update
                    </button>
                        <button
                          className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                          type="button" onClick={() => this.moveClientList()}> {" "} Cancel{" "}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  renderFleetManagerCard = () => {
    const { showSidePane, ClientUserDetails } = this.props;
    const { FleetManager } = this.state;
    return (
      <>
        {FleetManager && FleetManager.length ? FleetManager.map(item => (
          <div className="card click" style={{ backgroundColor: "#f0f0f0", overflow: "hidden", position: "relative" }}>
            <div className="p-3">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className="col-sm-9 col-md-10 col-9 col-m-auto">
                    <div className="row">
                      <div className={showSidePane ? "col-sm-6 py-1" : "col-sm-4"}>
                        <span><strong>Name : </strong>{item.name}</span>
                      </div>
                      <div className={showSidePane ? "col-sm-6 py-1" : "col-sm-4"}>
                        <span><strong>Email : </strong>{item.email}</span>
                      </div>
                      <div className={showSidePane ? "col-sm-6 py-1" : "col-sm-4"}>
                        <span><strong>Phone : </strong>{item.phone}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-3 col-md-2 col-3 col-m-auto">
                    <div className={"text-center"} style={{ marginLeft: '-10px' }}>
                      <i className="fa fa-trash m-1 fa-2x" onClick={() => this.DeletePopup(item)}></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))
          : null
        }
      </>
    )
  }
  renderTechSuperintendentCard = () => {
    const { showSidePane, ClientUserDetails } = this.props;
    const { TechSuperintendent } = this.state;
    return (
      <>
        {TechSuperintendent && TechSuperintendent.length ? TechSuperintendent.map(item => (
          <div className="card click" style={{ backgroundColor: "#f0f0f0", overflow: "hidden", position: "relative" }}>
            <div className="p-3">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className="col-sm-9 col-md-10 col-9 col-m-auto">
                    <div className="row">
                      <div className={showSidePane ? "col-sm-6 py-1" : "col-sm-4"}>
                        <span><strong>Name : </strong>{item.name}</span>
                      </div>
                      <div className={showSidePane ? "col-sm-6 py-1" : "col-sm-4"}>
                        <span><strong>Email : </strong>{item.email}</span>
                      </div>
                      <div className={showSidePane ? "col-sm-6 py-1" : "col-sm-4"}>
                        <span><strong>Phone : </strong>{item.phone}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-3 col-md-2 col-3 col-m-auto">
                    <div className={"text-center"} style={{ marginLeft: '-10px' }}>
                     
                      <i className="fa fa-trash fa-2x m-1" onClick={() => this.DeletePopup(item)}></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))
          : null
        }
      </>
    )
  }
  renderTechExecutiveCard = () => {
    const { showSidePane, ClientUserDetails } = this.props;
    const { TechExecutive } = this.state;
    return (
      <>
        {TechExecutive && TechExecutive.length ? TechExecutive.map(item => (
          <div className="card click" style={{ backgroundColor: "#f0f0f0", overflow: "hidden", position: "relative" }}>
            <div className="p-3">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className="col-sm-9 col-md-10 col-9 col-m-auto">
                    <div className="row">
                      <div className={showSidePane ? "col-sm-6 py-1" : "col-sm-4"}>
                        <span><strong>Name : </strong>{item.name}</span>
                      </div>
                      <div className={showSidePane ? "col-sm-6 py-1" : "col-sm-4"}>
                        <span><strong>Email : </strong>{item.email}</span>
                      </div>
                      <div className={showSidePane ? "col-sm-6 py-1" : "col-sm-4"}>
                        <span><strong>Phone : </strong>{item.phone}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-3 col-md-2 col-3 col-m-auto">
                    <div className={"text-center"} style={{ marginLeft: '-10px' }}>
                      
                      <i className="fa fa-trash fa-2x m-1" onClick={() => this.DeletePopup(item)}></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))
          : null
        }
      </>
    )
  }

  moveClientList = () => {
    this.props.dispatch({ type: "GetTechExecutivelist", data: null });
    this.props.dispatch({ type: "GetTechSuperintendentlist", data: null });
    this.props.dispatch({ type: "GetFleetManagerlist", data: null });
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/Management/Client");
  };

  DeletePopup(item) {
    confirmAlert({
        message: 'Are you sure want to delete ?',
        buttons: [
            {
                label: 'Yes',
                onClick: () => {
                    this.DeleteUser(item)
                }
            },
            {
                label: 'No',
                onClick: () => { }
            }
        ]
    });
    }

  DeleteUser(item) {
    const { dispatch,match } = this.props;
    let clientuserArray = [];
    clientuserArray.push(item.clientUserId);
    let clientuser =[ {
      clientUserIds:clientuserArray.toString(),
      clientId:parseInt(match.params.id),
      isDeleted: true,
      modifiedBy: user.email
    }]
    let url = `${API.ClientUser}`;
    axios.put(url, clientuser, {
      headers: {
        key: user.accessToken,
      }
    })
      .then((response) => {
        dispatch(getClientUserList(item.clientId));
        dispatch({
          type: "postClientUserDetailsSuccess",
          data: response.data,
        })
      })
      .catch((error) => {
        dispatch({
          type: "postClientUserDetailsFailure",
          error: "ERROR"
        })
      })
    //  this.props.dispatch(putClientUserDetails(clientuserArray));
  }

  EditUser(type, item) {
    const { match } = this.props;
    this.props.dispatch({ type: "EditUser", data: true });
    if (type === "FleetManager") {
      this.props.dispatch({ type: "GetFleetManagerDetails", data: item });
      this.props.dispatch({ type: "GetFleetManagerlist", data: this.state.FleetManager });
      this.props.dispatch({ type: "ShowSidePan", data: true });
      this.props.history.push(`/Home/Management/ClientEdit/${match.params.id}/FleetManager`);
    }
    else if (type === "TechSuperintendent") {
      this.props.dispatch({ type: "GetTechSuperintendentDetails", data: item });
      this.props.dispatch({ type: "ShowSidePan", data: true });
      this.props.history.push(`/Home/Management/ClientEdit/${match.params.id}/TechSuperintendent`);
    }
    else if (type === "TechExecutive") {
      this.props.dispatch({ type: "GetTechExecutiveDetails", data: item });
      this.props.dispatch({ type: "ShowSidePan", data: true });
      this.props.history.push(`/Home/Management/ClientEdit/${match.params.id}/TechExecutive`);
    }
  }

  showFleetManagersSidePane() {
    const { match } = this.props;
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.dispatch({ type: "EditUser", data: false });
    this.props.dispatch({ type: "GetFleetManagerDetails", data: null });
    this.props.history.push(`/Home/Management/ClientEdit/${match.params.id}/FleetManager`);
  }

  showTechSuperintendentsSidePane() {
    const { match } = this.props;
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.dispatch({ type: "EditUser", data: false });
    this.props.dispatch({ type: "GetTechSuperintendentDetails", data: null });
    this.props.history.push(`/Home/Management/ClientEdit/${match.params.id}/TechSuperintendent`);
  }

  showTechExecutiveSidePane() {
    const { match } = this.props;
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.dispatch({ type: "EditUser", data: false });
    this.props.dispatch({ type: "GetTechExecutiveDetails", data: null });
    this.props.history.push(`/Home/Management/ClientEdit/${match.params.id}/TechExecutive`);
  }
}
function mapStateToProps(state) {
  return {
    ClientDetails: state.MasterScreenReducer.ClientDetails,
    ClientUserDetails: state.MasterScreenReducer.ClientUserDetails,
    showSidePane: state.SidePanReducer.sidePan || false,
    fleetManagerlist: state.MasterScreenReducer.fleetManagerlist,
    TechSuperintendentlist: state.MasterScreenReducer.TechSuperintendentlist,
    TechExecutivelist: state.MasterScreenReducer.TechExecutivelist,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ClientManagementEdit);
